import { useSetAtom } from 'jotai'
import React from 'react'

import {
  brandAccountIdLastSurveyIdMapAtom,
  lastBrandAccountIdAtom,
  lastSurveyIdAtom,
} from '~/atoms'
import { useCommonQueryCurrentBrandAccount } from '~/hooks/useCommonQuery'
import { useCurrentSurvey } from '~/hooks/useCurrentSurvey'
import { exists } from '~/utils'

/**
 * 最後に訪問したブランドアカウントとサーベイをatomに設定するカスタムフックです。
 */
export const useSetLastVisitedEffect = () => {
  const brandAccount = useCommonQueryCurrentBrandAccount()
  const survey = useCurrentSurvey()

  const setLastBrandAccountId = useSetAtom(lastBrandAccountIdAtom)
  const setLastSurveyId = useSetAtom(lastSurveyIdAtom)
  const setBrandAccountIdLastSurveyIdMap = useSetAtom(
    brandAccountIdLastSurveyIdMapAtom,
  )

  React.useEffect(() => {
    if (exists(brandAccount)) {
      setLastBrandAccountId(brandAccount.id)
    }

    if (survey.success) {
      setLastSurveyId(survey.value.id)
    }

    if (exists(brandAccount) && survey.success) {
      setBrandAccountIdLastSurveyIdMap((brandAccountIdLastSurveyIdMap) =>
        exists(brandAccountIdLastSurveyIdMap)
          ? {
              ...brandAccountIdLastSurveyIdMap,
              [brandAccount.id]: survey.value.id,
            }
          : {
              [brandAccount.id]: survey.value.id,
            },
      )
    }
  }, [
    brandAccount,
    setBrandAccountIdLastSurveyIdMap,
    setLastBrandAccountId,
    setLastSurveyId,
    survey,
  ])
}
